import { render, staticRenderFns } from "./SeedForm.vue?vue&type=template&id=d384bf36"
import script from "./SeedForm.vue?vue&type=script&lang=ts"
export * from "./SeedForm.vue?vue&type=script&lang=ts"
import style0 from "./SeedForm.vue?vue&type=style&index=0&id=d384bf36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports